import '../css/index.less';
import DPlayer from './player';
export default DPlayer;